import styled, { CSSProperties } from "styled-components";

interface StyledProps {
  customStyles?: CSSProperties;
}

export const GridWrapper = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  ${(props) =>
    props?.customStyles &&
    Object.entries(props.customStyles)
      .map(
        ([key, value]) =>
          `${key.replace(
            /[A-Z]/g,
            (match) => `-${match.toLowerCase()}`
          )}: ${value};`
      )
      .join("\n")}
`;
export const Wrapper = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  margin: auto;
  max-width: 970px;
  justify-content: space-between;
  flex-wrap: wrap;
  ${(props) =>
    props?.customStyles &&
    Object.entries(props.customStyles)
      .map(
        ([key, value]) =>
          `${key.replace(
            /[A-Z]/g,
            (match) => `-${match.toLowerCase()}`
          )}: ${value};`
      )
      .join("\n")}
`;

export const ButtonWrapper = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  margin: auto;
  max-width: 970px;
  justify-content: end;
  padding-right: 20px;
  ${(props) =>
    props?.customStyles &&
    Object.entries(props.customStyles)
      .map(
        ([key, value]) =>
          `${key.replace(
            /[A-Z]/g,
            (match) => `-${match.toLowerCase()}`
          )}: ${value};`
      )
      .join("\n")}
`;
export const InputLabelText = styled.div<StyledProps>`
  font-size: 18px;
  font-weight: 600;
  margin-right: 18px;
  ${(props) =>
    props?.customStyles &&
    Object.entries(props.customStyles)
      .map(
        ([key, value]) =>
          `${key.replace(
            /[A-Z]/g,
            (match) => `-${match.toLowerCase()}`
          )}: ${value};`
      )
      .join("\n")}
`;
